<template>
  <span>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Call Sign</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.call_sign"
              class="form-control"
              autocomplete="off"
              placeholder="Call Sign"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Disponent Owner</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.disponent_owner"
              class="form-control"
              autocomplete="off"
              placeholder="Disponent Owner"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">GRT</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.grt"
              class="form-control"
              autocomplete="off"
              placeholder="GRT"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">Grabs fitted</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.grabs_fitted"
              class="form-control"
              autocomplete="off"
              placeholder="Grabs fitted"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Ex-Name</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ex_name"
              class="form-control"
              autocomplete="off"
              placeholder="Ex-Name"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Operator</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.operator"
              class="form-control"
              autocomplete="off"
              placeholder="Operator"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">NRT</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.nrt"
              class="form-control"
              autocomplete="off"
              placeholder="NRT"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">Grabs number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.grabs_number"
              class="form-control"
              autocomplete="off"
              placeholder="Grabs number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Yard</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.yard"
              class="form-control"
              autocomplete="off"
              placeholder="Yard"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">H&M</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.h_m"
              class="form-control"
              autocomplete="off"
              placeholder="H&M"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Panama Gross</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.panama_gross"
              class="form-control"
              autocomplete="off"
              placeholder="Panama Gross"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">Grabs capacity</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.grabs_capacity"
              class="form-control"
              autocomplete="off"
              placeholder="Grabs capacity"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Ship Builder</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ship_builder"
              class="form-control"
              autocomplete="off"
              placeholder="Ship Builder"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">H&M Value</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.h_m_value"
              class="form-control"
              autocomplete="off"
              placeholder="H&M Value"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Panama Net</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.panama_net"
              class="form-control"
              autocomplete="off"
              placeholder="Panama Net"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">TT Strength</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.tt_strength"
              class="form-control"
              autocomplete="off"
              placeholder="TT Strength"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Hull Number</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.hull_number"
              class="form-control"
              autocomplete="off"
              placeholder="Hull Number"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">P&I</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.p_l"
              class="form-control"
              autocomplete="off"
              placeholder="P&I"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Suez Gross</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.suez_gross"
              class="form-control"
              autocomplete="off"
              placeholder="Suez Gross"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">Class Name</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.class_name"
              class="form-control"
              autocomplete="off"
              placeholder="Class Name"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Last DD</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.last_dd"
              class="form-control"
              autocomplete="off"
              placeholder="Last DD"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Neo Panama fitted</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.neo_panama_fitted"
              class="form-control"
              autocomplete="off"
              placeholder="Neo Panama fitted"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Ice Class</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.ice_class"
              class="form-control"
              autocomplete="off"
              placeholder="Ice Class"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-4">
          <label class="col-sm-4 col-form-label">Next DD</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.next_dd"
              class="form-control"
              autocomplete="off"
              placeholder="Next DD"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Main Engine Make</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.main_engine_make"
              class="form-control"
              autocomplete="off"
              placeholder="Main Engine Make"
            />
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="mb-3">
          <label class="col-form-label">Next SS</label>
          <div class="col-sm-12">
            <input
              type="text"
              v-model="form.next_ss"
              class="form-control"
              autocomplete="off"
              placeholder="Next SS"
            />
          </div>
        </div>
      </div>
    </div>
  </span>
</template>

<script type="text/javascript">
// import axios from "axios";
export default {
  name: "Vessel2FormWidget",
  props: ["form"],
  data() {
    return {
      //   vessels: [],
    };
  },
  mounted() {
    // this.getMasters();
  },
  methods: {
    // async getMasters() {
    //   let masters = await axios.get("vessels/masters");
    //   masters = masters.data;
    //   masters.vessels.forEach((vessel) => {
    //     this.vessels.push({
    //       id: vessel.id,
    //       name: vessel.name,
    //     });
    //   });
    // },
  },
};
</script>
